/* jshint ignore: start */
// jscs:disable

// todo:
// remove offscreen
// remove overlaps
// add attr 'scale' for moving things ... maybe

(function($) {

    $.fn.RandomLayout = function(options) {

        // plugin
        var plugin = this;

        // settings
        plugin.MIN_RECT_WIDTH = 160;
        plugin.MIN_RECT_HEIGHT = 160;
        plugin.MAX_RECT_WIDTH = 220;
        plugin.MAX_RECT_HEIGHT = 200;
        plugin.MIN_PADDING_X = 50;
        plugin.MIN_PADDING_Y = 50;
        plugin.MAX_PADDING_X = 50;
        plugin.MAX_PADDING_Y = 50;


        // vars
        var imgRects = [];
        plugin.imgRects = imgRects;
        var $element = this;

        var currentHeight = 0;
        var currentWidth = 0;
        var resizeDebounce;

        $element.data('RandomLayout', plugin);

        var settings = $.extend({
            data: []
        }, options);

        plugin.init = function() {
            imgRects = [];
            plugin.demo_add_images();
        };

        plugin.show = function() {
            var gridItem = $element.find('.rand-img');
            gridItem.css({visibility: 'visible'});
            for (i = 0; i < gridItem.length; i++) {
                TweenMax.to($(gridItem[i]), 1.40, {
                    alpha: 1,
                    delay: i / gridItem.length
                });
            }
        }

        plugin.demo_add_images = function() {
            var i;
            var j;
            var domString = "";
            for (i = 0; i < settings.data.length; i++) {
                domString += "<div class='rand-img parallax' ";
                domString += "data-slug='";
                domString += settings.data[i].slug;
                domString += "' ";
                domString += "data-image-index='";
                domString += settings.data[i].imageIndex;
                domString += "' ";
                domString += "data-terms='";
                domString += settings.data[i].tags.toString();
                domString += "' >";
                domString += "<a class='rand-img__link'><div class='rand-img__link__info'><div class='rand-img__link__info__info'>";
                domString += "<div class='rand-img__link__info__info__artist'>";
                domString += settings.data[i].artist;
                domString += "</div>";
                domString += "<div class='rand-img__link__info__info__title'>";
                domString += settings.data[i].title;
                domString += "</div>";
                domString += "<div class='rand-img__link__info__info__year'>";
                domString += settings.data[i].year;
                domString += "</div>";
                domString += "</div></div>";
                domString += "<img class='rand-img__link__img'";
                domString += " data-width='" + settings.data[i].imageWidth + "'";
                domString += " data-height='" + settings.data[i].imageHeight + "'";
                domString += " data-large='" + settings.data[i].imageLarge + "'";
                domString += " src='" + settings.data[i].image + "'>";
                domString += "</a></div>";
            }

            $element.append(domString);

            // Trigger event
            $element.find('.rand-img').on('click', function() {
                $element.trigger('ITEM_CLICKED', this);
            });

            imagesLoaded($element, function(instance) {
                $element.trigger('IMAGES_LOADED', this);
            });
        };

        plugin.pack = function() {
            var MAX_HEIGHT = 310;
            var MAX_WIDTH = 310;
            var MIN_HEIGHT = 63;
            var MIN_WIDTH = 110;

            var gridItem = $element.find('.rand-img');
            var centerX = $(window).width() / 2;
            var centerY = $(window).height() / 2;
            var x;
            var y;
            var currentPosition = 0;
            var r = plugin.MAX_RECT_WIDTH + plugin.MIN_PADDING_X;
            var rand;
            var $firstItem = $(gridItem[0]);
            var $giImg;

            for (i = 0; i < gridItem.length; i++) {

                $(gridItem[i]).css({opacity: 0});

                $giImg = $(gridItem[i]).find('img');
                rand = plugin.getRandomBetween(240, 310);
                if (parseInt($giImg.attr('data-height'), 10) >= parseInt($giImg.attr('data-width'), 10)) {
                    $giImg.height(rand);
                    $giImg.width('auto');
                    if ($giImg.width() < MIN_WIDTH) {
                        $giImg.height(MAX_HEIGHT);
                        $giImg.width('auto');
                    }
                } else {
                    $giImg.width(rand);
                    $giImg.height('auto');

                    if ($giImg.height() < MIN_HEIGHT) {
                        $giImg.width(MAX_WIDTH);
                        $giImg.height('auto');
                    }
                }

                if ((parseInt($giImg.attr('data-width'),10)/parseInt($giImg.attr('data-height'),10)) > 9) {
                    $giImg.height(80);
                    $giImg.width('auto');
                    $giImg.attr('src', $giImg.attr('data-large'));
                }

                $(gridItem[i]).width($giImg.width());
                $(gridItem[i]).height($giImg.height());
                $(gridItem[i]).find('.rand-img__link, .rand-img__link__info').width($giImg.width());
                $(gridItem[i]).find('.rand-img__link, .rand-img__link__info').height($giImg.height());
            }

            $(window).resize(onResize);
            $(window).resize();

        }

        function onResize() {
            clearTimeout(resizeDebounce);
            resizeDebounce = setTimeout(function() {
                if (
                    $(window).width() != currentWidth ||
                    $(window).height() != currentHeight
                ) {
                    currentWidth = $(window).width();
                    currentHeight = $(window).height();
                    $element.arrange({slack: 30, arrange: '.rand-img'});
                }
            }, 300);
        }

        plugin.packOld = function() {

            var imgWraps = $element.find('.rand-img');
            for (i = 0; i < imgWraps.length; i++) {
                plugin.createRandomRectangle($(imgWraps[i]));
            }

            plugin.layout();
            //plugin.removeOffscreenElements();
            //plugin.removeOverlapElements();
            //plugin.packComplete();

            // $(window).on('resize', plugin.resize);

            $element.trigger('LAYOUT_COMPLETE');
        };

        $(window).resize(function() {
   //       var i;
   //       for (i = 1; i < imgRects.length; i++) {
   //           imgRects[i].packed = false;
   //       }
            // plugin.layout();
            // plugin.removeOffscreenElements();
            // plugin.removeOverlapElements();
            // plugin.packComplete();


            // clearTimeout(resizeDebounce);
            // resizeDebounce = setTimeout(function() {
            //     window.kill();
            //     window.init();
            // }, 300);

        });

        plugin.createRandomRectangle = function($imgWrap) {

            var $img = $imgWrap.find('img');
            var randomRect = {
                id: i,
                top: 0,
                left: 0,
                width: plugin.getRandomBetween(plugin.MIN_RECT_WIDTH, plugin.MAX_RECT_WIDTH),
                marginLeft: plugin.getRandomBetween(plugin.MIN_PADDING_X, plugin.MAX_PADDING_X),
                marginRight: plugin.getRandomBetween(plugin.MIN_PADDING_X, plugin.MAX_PADDING_X),
                marginTop: plugin.getRandomBetween(plugin.MIN_PADDING_Y, plugin.MAX_PADDING_Y),
                marginBottom: plugin.getRandomBetween(plugin.MIN_PADDING_Y, plugin.MAX_PADDING_Y),
                getTotalWidth: function() {
                    return this.marginLeft + this.marginRight + this.width;
                },
                getTotalHeight: function() {
                    return this.marginTop + this.marginBottom + this.height;
                },
                $imgWrap: $imgWrap
            };

            $img.css({
                width: randomRect.width
            });

            randomRect.height = $img.height();

            // -- -- -- -- --
            // Check to make sure that the image is not taller then the MAX_RECT_HEIGHT
            // if so we make it a random height between the allowed min / max height
            // and set width to be auto
            // -- -- -- -- --

            if ($img.height() > plugin.MAX_RECT_HEIGHT) {
                $img.height(plugin.getRandomBetween(plugin.MIN_RECT_HEIGHT, plugin.MAX_RECT_HEIGHT));
                $img.width('auto');
                randomRect.width = $img.width();
                randomRect.height = $img.height();
            }

            $imgWrap.css({
                'top': randomRect.top,
                'left': randomRect.left,
                'width': randomRect.getTotalWidth(),
                'height': randomRect.getTotalHeight()
            });

            $imgWrap.find('.rand-img__link__info').css({
                width: randomRect.width,
                height: randomRect.height
            });

            $imgWrap.find('a').css({
                marginLeft: randomRect.marginLeft,
                marginRight: randomRect.marginRight,
                marginTop: randomRect.marginTop,
                marginBottom: randomRect.marginBottom,
                width: randomRect.width,
                height: randomRect.height
            });

            imgRects.push(randomRect);

            return randomRect;
        },

        plugin.layout = function() {

            var lastRow = [];
            var currentRow = [];
            var rowCT = 0;

            overX = 0;
            overY = 0;

            currentRow.push(imgRects[0]);

            for (var i = 1; i < imgRects.length; i++) {

                var lastRect = imgRects[i - 1];
                var currentRect = imgRects[i];

                if (lastRect.left + lastRect.getTotalWidth() + currentRect.getTotalWidth() < $element.width()) {
                    overX = lastRect.left + lastRect.getTotalWidth();
                    currentRow.push(currentRect);

                } else {

                    rowCT++;

                    if (rowCT === 2) {
                        plugin.pullRowDown(lastRow);
                    }

                    plugin.pullRowUp(lastRow, currentRow);

                    lastRow = currentRow;

                    plugin.centerRow(lastRow);

                    currentRow = [currentRect];

                    overY += plugin.MAX_RECT_HEIGHT + plugin.MAX_PADDING_Y * 2;

                    overX = 0;
                }

                currentRect.left = overX;
                currentRect.top = overY;
            }

            plugin.centerRow(currentRow);
            plugin.pullRowUp(lastRow, currentRow);
        },

        plugin.removeOffscreenElements = function() {
            var i;
            for (i = 0; i < imgRects.length; i++) {
                var imgRect = imgRects[i];
                if (
                    imgRect.top < 0 ||
                    imgRect.left < 0 ||
                    imgRect.left + imgRect.getTotalWidth() > $element.width() ||
                    imgRect.top + imgRect.getTotalHeight() > $element.height()) {
                    imgRect.packed = false;
                } else {
                    imgRect.packed = true;
                }
            }
        },

        plugin.packComplete = function() {
            var i;
            for (i = 0; i < imgRects.length; i++) {
                if (imgRects[i].packed === true) {
                    imgRects[i].$imgWrap.css({
                        left: imgRects[i].left,
                        top: imgRects[i].top,
                        visibility: 'visible'
                    });
                } else {
                    imgRects[i].$imgWrap.detach();
                }
            }
        },

        plugin.pullRowDown = function(a) {
            var i;
            for (i = 0; i < a.length; i++) {
                a[i].top += Math.random() * a[i].getTotalHeight() / 2;
            }
        },

        plugin.pullRowUp = function(a, b) {
            var i;
            var j;
            for (j = 0; j < b.length; j++) {
                var maxDown = 0;
                for (i = 0; i < a.length; i++) {
                    if (plugin.rectangle_collision_x(b[j], a[i]) || plugin.rectangle_collision_x(a[i], b[j])) {
                        if (a[i].top + a[i].getTotalHeight() > maxDown) {
                            b[j].top = maxDown = a[i].top + a[i].getTotalHeight();
                        }
                    }
                }
            }
        },

        plugin.centerRow = function(a) {
            var rowWidth = 0;
            var i;
            for (i = 0; i < a.length; i++) {
                rowWidth += a[i].getTotalWidth();
            }
            var rowPadding = (($element.width() - rowWidth) / 2);
            for (i = 0; i < a.length; i++) {
                a[i].left += rowPadding;
            }
        },

        plugin.removeOverlapElements = function() {
            var addedRects = [];
            var i;
            for (i = 0; i < imgRects.length; i++) {
                if (imgRects[i].packed === true) {
                    addedRects.push(imgRects[i]);
                }
            }
            for (i = 0; i < addedRects.length-1; i++) {
                for (j = i + 1; j < addedRects.length; j++) {
                    if (plugin.checkInnerHit(addedRects[i], addedRects[j])) {

                        // addedRects[i].$imgWrap.css('border', '2px solid red');
                        // addedRects[j].$imgWrap.css('border', '2px solid red');

                        var max = 0;
                        var removeMe;
                        if (addedRects[i].getTotalWidth() > max) {
                            max = addedRects[i].getTotalWidth();
                            removeMe = addedRects[i];
                        }
                        if (addedRects[j].getTotalWidth() > max) {
                            max = addedRects[j].getTotalWidth();
                            removeMe = addedRects[j];
                        }
                        if (addedRects[i].getTotalHeight() > max) {
                            max = addedRects[i].getTotalHeight();
                            removeMe = addedRects[i];
                        }
                        if (addedRects[j].getTotalHeight() > max) {
                            max = addedRects[j].getTotalHeight();
                            removeMe = addedRects[j];
                        }
                        removeMe.packed = false;
                    }
                }
            }
        },

        // -- -- -- -- --
        // UTIL
        // -- -- -- -- --

        plugin.checkInnerHit = function(_a, _b) {
            var a = {
                x: _a.left + _a.marginLeft,
                y: _a.top + _a.marginTop,
                w: _a.width + _a.marginRight,
                h: _a.height + _a.marginBottom,
                id: _a.id
            };
            var b = {
                x: _b.left + _b.marginLeft,
                y: _b.top + _b.marginTop,
                w: _b.width + _b.marginRight,
                h: _b.height + _b.marginBottom,
                id: _b.id
            };

            return (!(a.x > b.x + b.w || a.x + a.w < b.x || a.y > b.y + b.h || a.y + a.h < b.y));
        }

        plugin.rectangle_collision_x = function(a, b) {
            var x_1 = a.left;
            var width_1 = a.getTotalWidth();
            var x_2 = b.left;
            var width_2 = b.getTotalWidth();
            return !(x_1 > x_2+width_2 || x_1+width_1 < x_2);
        },

        plugin.rectangle_collision_y = function(a, b) {
            var y_1 = a.top;
            var height_1 = a.getTotalHeight();
            var y_2 = b.top;
            var height_2 = b.getTotalHeight();
            return !(y_1 > y_2+height_2 || y_1+height_1 < y_2);
        },

        plugin.getRandomBetween = function(_min, _max, decimals) {
            decimals = (decimals === "undefined") ? 1 : decimals;
            return Math.floor(Math.random() * (_max - _min + 1), decimals) + _min;
        },

        plugin.destroy = function() {
            $element.html('');
            $(window).unbind('resize', onResize);
        }

        plugin.init();

        return plugin;
    };
})(jQuery);

/* jshint ignore: end */
// jscs:enable
